import styled from "styled-components";
import * as Types from "Types";

import H4 from "Components/Atoms/H4";

const Wrap = styled.div<Types.Default>`
   display: flex;
   flex-direction: column;
   align-items: center;
   ${({ css }) => css}
`;

const Text = styled(H4)<Types.Default>`
   line-height: 33px;
   ${({ css }) => css}
`;

export default function Content1(props: Types.Default) {
   return (
      <Wrap {...props}>
         <Text>
            <p>실시간 전시회 데이터 베이스 No.1</p>
            <p>국내 유일의 아트 큐레이션 플랫폼 아트맵</p>
         </Text>
      </Wrap>
   );
}
